<template>
	<div>
		<div v-if="!hideCookieAlert"  class="fixed bottom-0 left-0 w-screen">
			<div class="mb-2 mx-2 cookie-alert rounded">
				<!--<div class="flex justify-between p-4">
					<div class="text-white">Datenschutz erklärung</div>
					<div class="mt-1">
						<svg class="fill-current text-white h-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z"/></svg>
					</div>
				</div>-->
				<div class="flex p-4">
					<div class="w-3/4 text-white">
						<p class="inline">{{ $t('component.cookieAlert.text1') }}</p>
						<p @click="privacyNoticeShow = true" class="cursor-pointer inline underline">{{ $t('component.cookieAlert.text2') }}</p>
						<p class="inline">{{ $t('component.cookieAlert.text3') }}</p>
						<p class="cursor-pointer underline mt-2" @click="settings">{{ $t('component.cookieAlert.settings') }}</p>
					</div>
					<div class="w-1/4 flex flex-wrap content-center justify-center">
						<button class="bg-white p-2 rounded font-semibold text-black hover:bg-red-600 hover:text-white"
								@click="accept">{{ $t('component.cookieAlert.submit') }}</button>
					</div>
				</div>
			</div>

			<ModalBase v-show="privacyNoticeShow" modal-type="initial" @close="privacyNoticeShow = !privacyNoticeShow">
				<template #header>
					{{ $t('component.privacyNotice.header') }}
				</template>
				<template #body>
					<div class="mt-4 overflow-x-auto border p-2 shadow-inner text-sm" style="height: 300px;">
						<div>
							<div class="font-bold">{{ $t('component.privacyNotice.part.1.header') }}</div>
							<div>
								<p>{{ $t('component.privacyNotice.part.1.text1') }}</p>
								<p class="mt-4">{{ $t('component.privacyNotice.part.1.text2') }}</p>
							</div>
						</div>
						<div class="mt-4">
							<div class="font-bold">{{ $t('component.privacyNotice.part.2.header' )}} </div>
							<div>
								<p>{{ $t('component.privacyNotice.part.2.text1' )}} </p>
								<p class="mt-4">{{ $t('component.privacyNotice.part.2.text2' )}}</p>
								<p class="mt-4">{{ $t('component.privacyNotice.part.2.text3' )}}</p>
								<p class="mt-4">
									{{ $t('component.privacyNotice.part.2.text4' )}}
								</p>
							</div>
						</div>

						<div class="mt-4">
							<div class="font-bold">{{ $t('component.privacyNotice.part.3.header') }}</div>
							<div>
								<p>
									{{ $t('component.privacyNotice.part.3.text1') }}
								</p>
								<p class="mt-4">{{ $t('component.privacyNotice.part.3.text2') }}</p>
								<p class="mt-4">{{ $t('component.privacyNotice.part.3.text3') }}</p>
								<p v-html="$t('component.privacyNotice.part.3.text4')">
								</p>
							</div>
						</div>

						<div class="mt-4">
							<div class="font-bold">{{ $t('component.privacyNotice.part.4.header') }}</div>
							<div>
								<p>{{ $t('component.privacyNotice.part.4.text1') }}</p>
								<p class="mt-4">{{ $t('component.privacyNotice.part.4.text2') }}</p>
								<p class="mt-4">{{ $t('component.privacyNotice.part.4.text3') }}</p>
								<p class="mt-4" v-html="$t('component.privacyNotice.part.4.text4')">
								</p>
								<p class="mt-4">{{ $t('component.privacyNotice.part.4.text5') }}</p>
								<p class="mt-4" v-html="$t('component.privacyNotice.part.4.text6')">
								</p>
							</div>
						</div>
					</div>
				</template>
				<template #footer>
					<div class="flex">
						<button @click="privacyNoticeShow = false"
								class="border rounded py-2 px-4 mt-4 cursor-pointer shadow w-24">
							{{ $t('dialog.privacyNotice.close') }}
						</button>
					</div>
				</template>
			</ModalBase>
		</div>
	</div>
</template>

<script>
    import {mapGetters} from "vuex";
    import ModalBase from "./shared/ModalBase";

    export default {
        name: "CookieAlert",
		components: {
            ModalBase
		},
		data() {
            return {
                privacyNoticeShow: false
			}
		},
		computed: {
            ...mapGetters('app', {
                hideCookieAlert: 'hideCookieAlert'
            })
		},
		methods: {
            accept() {
                this.$store.dispatch('app/hideCookieAlert');
			},

			settings() {
                this.$store.commit('app/showGdprModal');
			}
		}
    }
</script>

<style scoped>
	.cookie-alert {
		background-color: #2a2a2a;
		opacity: 1.0;
	}
</style>